import { Component } from '@angular/core'
import { CustomerSelectionComponent } from '@spartacus/asm/components'

@Component({
    selector: 'eb-customer-selection',
    templateUrl: './eb-customer-selection.component.html',
    standalone: false
})
export class EbCustomerSelectionComponent extends CustomerSelectionComponent {

  onSubmit(): void {
    if (this.customerSelectionForm.valid && !!this.selectedCustomer) {
      this.submitEvent.emit({ customerId: this.selectedCustomer.uid })
    } else {
      this.customerSelectionForm.markAllAsTouched()
    }
  }
}
